import { AccountSettingsPayload } from '@account-users/account/models/AccountSettingsPayload';
import { EditAccountLicense } from '@account-users/account/models/EditAccountLicense';
import { AccountState, IAccount } from '@account-users/account/models/IAccount';
import { License, LicensePackage } from '@account-users/account/models/License';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  HostBinding,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';

@Component({
  selector: 'app-manage-license-packages',
  templateUrl: './manage-licenses.component.html',
  styleUrls: ['./manage-licenses.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ManageLicensesComponent implements OnChanges {
  @HostBinding('class.disabled') @Input() disabled: boolean;
  @Input() accountId: string;
  @Input() isUpdatingLicense: boolean;
  @Input() canPlaceOrders: boolean;
  @Input() accountState: AccountState;
  @Input() accountDetails: IAccount;
  @Input() licenseTypes: License[];
  @Input() isLoadingLicensePackages: boolean;
  @Input() licensePackagesError: boolean;
  @Input() licenseBootstrapState: AccountState;
  @Input() sectionsTotal: number;
  @Input() isUpdatingUserSeats: boolean;
  @Input() slimPackageNotEnabled: boolean;
  @Input() disablePackage: boolean;
  @Input() hasOrderManagerRole: boolean;
  @Input() hasWawRole: boolean;
  @Input() licensePackages: LicensePackage[];

  @Output() openEditPackage = new EventEmitter<boolean>();
  @Output() updateLicensePackage = new EventEmitter<AccountSettingsPayload>();
  @Output() editAccountLicense = new EventEmitter<EditAccountLicense>();

  public readonly sharePointUrl =
    'https://efficy.sharepoint.com/:b:/s/ApsisRnD/EZXqje6oSBpFrABHow_3AuUBNOhIzhnzejASBUcW3k8UAw?e=zefoZx';
  public packageOptions: { name: string; value: string }[];
  public openEdit = false;

  private _licensePackages: Record<string, LicensePackage> = {};

  get licensePackage(): LicensePackage {
    return this._licensePackages[this.accountDetails.licensePackage];
  }

  ngOnChanges(changes: SimpleChanges) {
    const licensePackages = changes['licensePackages'];
    if (licensePackages?.currentValue) {
      this.normalizePackages(licensePackages.currentValue);
    }
  }

  public updatePackage($event) {
    this.updateLicensePackage.emit($event);
  }

  private normalizePackages(licensePackages: LicensePackage[]) {
    this._licensePackages = licensePackages.reduce((a, b) => {
      a[b.code] = b;
      return a;
    }, {});
    this.packageOptions = [...licensePackages].map((p) => {
      return { name: p.displayName, value: p.code };
    });
  }
}
